import * as React from 'react'
import {useTranslation} from 'react-i18next'
import Select from '../Fields/Select'
import {Link} from 'gatsby-plugin-react-i18next'
import FormLegend from '../Templates/FormLegend'
import Field from '../Fields/Field'
import * as routes from '../../../constants/routes'
import Checkbox from '../Fields/Checkbox'
import Textarea from '../Fields/Textarea'
import usePresentationFormOptions from '../../../hooks/usePresentationFormOptions'
import './PresentationFormVisibleFormFields.scss'

type Props = {showNewsletter?: boolean}

const PresentationFormVisibleFormFields = ({showNewsletter}: Props) => {
    const {t} = useTranslation()
    const {employeesOptions} = usePresentationFormOptions()

    return (
        <div className={'presentation-form__visible-fields-wrapper'}>
            <Field label={t('presentation_form_name')} name={'name'} isRequired={true} />
            <Field label={t('presentation_form_surname')} name={'surname'} isRequired={true} />
            <Field label={t('presentation_form_email')} name={'email'} type={'email'} isRequired={true} />
            <Field label={t('presentation_form_phone')} name={'phone'} isRequired={true} />
            <Field label={t('presentation_form_company')} name={'company'} isRequired={true} />
            <Field label={t('presentation_form_website')} name={'www'} isRequired={true} />
            <Select
                options={employeesOptions}
                label={t('presentation_form_employees')}
                isRequired={true}
                name={'employees'}
                wrapperClassName={'span-2-desktop'}
            />
            <Field
                label={t('presentation_form_nip')}
                name={'nip'}
                isRequired={false}
                wrapperClassName={'span-2-desktop'}
            />
            <Textarea
                label={t('presentation_form_additional')}
                name={'additional_info'}
                isRequired={false}
                wrapperClassName={'span-2-desktop'}
            />
            <Checkbox name={'consent_1'} isRequired={true} wrapperClassName={'span-2-desktop'}>
                {t('presentation_form_consent')}
                <Link className="has-text-primary" to={routes.TERMS}>
                    {t('presentation_form_consent_link')}
                </Link>
            </Checkbox>
            {!!showNewsletter && (
                <Checkbox name={'consent_2'} wrapperClassName={'span-2-desktop'}>
                    {t('presentation_form_newsletter')}
                    <Link className="has-text-primary" to={routes.TERMS}>
                        {t('presentation_form_consent_link')}
                    </Link>
                </Checkbox>
            )}
            <FormLegend required className={'span-2-desktop'} />
        </div>
    )
}

export default PresentationFormVisibleFormFields
